var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStepcheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 1.6665H4.99998C4.55795 1.6665 4.13403 1.8421 3.82147 2.15466C3.50891 2.46722 3.33331 2.89114 3.33331 3.33317V16.6665C3.33331 17.1085 3.50891 17.5325 3.82147 17.845C4.13403 18.1576 4.55795 18.3332 4.99998 18.3332H15C15.442 18.3332 15.8659 18.1576 16.1785 17.845C16.4911 17.5325 16.6666 17.1085 16.6666 16.6665V5.83317L12.5 1.6665Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 1.6665V4.99984C11.6667 5.44186 11.8423 5.86579 12.1548 6.17835C12.4674 6.49091 12.8913 6.6665 13.3334 6.6665H16.6667",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 12.5002L9.16667 14.1668L12.5 10.8335",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepcheck);
export default __webpack_public_path__ + "static/media/stepcheck.6b84f40946483795935be42f294a90a8.svg";
export { ForwardRef as ReactComponent };